import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper } from '@mui/material';
import { getAllApplications } from '../api';

const DateFilterTest = () => {
  const [startDate, setStartDate] = useState('2026-02-01');
  const [endDate, setEndDate] = useState('2026-02-05');
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);

  const testDateFilter = async () => {
    setLoading(true);
    try {
      console.log('[TEST] Testing date filter with:', { startDate, endDate });
      
      const response = await getAllApplications({
        page: 1,
        limit: 50,
        startDate,
        endDate
      });
      
      console.log('[TEST] API Response:', response);
      setResults(response);
    } catch (error) {
      console.error('[TEST] Error:', error);
      setResults({ error: error.message });
    } finally {
      setLoading(false);
    }
  };

  const testBackendDateFilter = async () => {
    setLoading(true);
    try {
      const response = await fetch(`/api/dashboard/test-date-filter?startDate=${startDate}&endDate=${endDate}`);
      const data = await response.json();
      console.log('[TEST] Backend test response:', data);
      setResults(data);
    } catch (error) {
      console.error('[TEST] Backend test error:', error);
      setResults({ error: error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Date Filter Test
      </Typography>
      
      <Box sx={{ mb: 3, display: 'flex', gap: 2, alignItems: 'center' }}>
        <TextField
          label="Start Date"
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="End Date"
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <Button 
          variant="contained" 
          onClick={testDateFilter}
          disabled={loading}
        >
          Test API Call
        </Button>
        <Button 
          variant="outlined" 
          onClick={testBackendDateFilter}
          disabled={loading}
        >
          Test Backend Logic
        </Button>
      </Box>

      {results && (
        <Paper sx={{ p: 2, mt: 2 }}>
          <Typography variant="h6" gutterBottom>
            Results:
          </Typography>
          <pre style={{ whiteSpace: 'pre-wrap', fontSize: '12px' }}>
            {JSON.stringify(results, null, 2)}
          </pre>
        </Paper>
      )}
    </Box>
  );
};

export default DateFilterTest;